export function siteHeader(isDarkHeader) {
	return {
		dropdown: null,
		backdropOpen: false,
		hoveredDropdown: null,
		dropdownLeft: window.innerWidth / 2,
		dropdownTrigger: null,
		menuOpen: false,
		scrolled: window.scrollY > 100,
		isDarkHeader,

		get useLightUi() {
			return this.scrolled || this.dropdown || this.menuOpen || !this.isDarkHeader;
		},

		init() {
			this.onScroll = () => (this.scrolled = window.scrollY > 100);
			this.onResize = () => this.positionDropdown(this.dropdownTrigger);

			window.addEventListener('scroll', this.onScroll, { passive: true });
			window.addEventListener('resize', this.onResize, { passive: true });

			this.$watch('dropdown', () => this.syncBodyScroll());
			this.$watch('menuOpen', () => this.syncBodyScroll());
		},

		destroy() {
			window.removeEventListener('scroll', this.onScroll);
			window.removeEventListener('resize', this.onResize);
			document.body.classList.remove('overflow-hidden');
		},

		syncBodyScroll() {
			document.body.classList.toggle('overflow-hidden', Boolean(this.dropdown || this.menuOpen));
		},

		positionDropdown(trigger) {
			if (!trigger) return;

			this.dropdownTrigger = trigger;

			const panelWidth = Math.min(800, window.innerWidth - 96);
			const halfPanel = panelWidth / 2;
			const triggerBox = trigger.getBoundingClientRect();
			const triggerCentre = triggerBox.left + triggerBox.width / 2;

			this.dropdownLeft = Math.min(window.innerWidth - halfPanel - 48, Math.max(halfPanel + 48, triggerCentre));
		},

		openDropdown(id, trigger) {
			this.positionDropdown(trigger);
			this.backdropOpen = true;
			this.dropdown = id;
			this.hoveredDropdown = id;
		},

		toggleDropdown(id, trigger) {
			if (this.hoveredDropdown === id) {
				this.hoveredDropdown = null;
				return;
			}

			if (this.dropdown === id) {
				this.closeDropdown();
				return;
			}

			this.openDropdown(id, trigger);
		},

		closeDropdown() {
			this.dropdown = null;
			this.backdropOpen = false;
			this.hoveredDropdown = null;
			this.dropdownTrigger = null;
		},

		toggleMenu() {
			this.menuOpen = !this.menuOpen;
			this.closeDropdown();
		},

		closeNavigation() {
			this.closeDropdown();
			this.menuOpen = false;
		},
	};
}
